import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import PostConfirmationPage from './component';
import { getIreneDashboard } from '@rental-manager/actions/requests';
import { ONBOARDING_COMPLETE } from '@rental-manager/constants/NotificationConstants';
import { showPageNotification } from '@common/actions/NotificationActions';

const mapStateToProps = (state, { propertyId, setupNewTerm, location }) => {
  const { tenantInvitationInfo } = state.payments.landlord.onboarding[propertyId];

  return {
    tenantFirstName: setupNewTerm ? location?.state?.tenantFirstName : tenantInvitationInfo.tenantFirstName,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }: any) => ({
  goToDashboard: (tenantFirstName) =>
    Promise.resolve()
      .then(() => dispatch(push(baseUrl)))
      .then(() => dispatch(getIreneDashboard({ propertyId })))
      .then(() => dispatch(showPageNotification(ONBOARDING_COMPLETE, { tenantFirstName }))),
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PostConfirmationPage);
